import { enumCultureGlobal } from "../models/constantEnumCulture";


/**
 * Dico avec clé provenant de l'enumerable de culture global
 */
export const CropSynonyms = {
    [enumCultureGlobal.colza]: ['colza', 'rapeseed', 'czh', 'czp'], // Colza ou colza d'hiver
    [enumCultureGlobal.mais]: ['mais', 'maïs', 'corn', 'mis'],
    [enumCultureGlobal.ble]: ['ble', 'blé', 'bth', 'trigo', 'wheat', 'tendre', 'soft', 'blando'],
    [enumCultureGlobal.ble_dur]: ['ble', 'blé', 'bdh', 'dur', 'durum', 'duro'],
    [enumCultureGlobal.orge]: ['orge', 'barley', 'orh', 'orge 6 rangs d\'hiver', 'escourgeon', 'cebada'],
    [enumCultureGlobal.pois_printemps]: ['pois', 'pois de printemps', 'printemps', 'peas', 'spring', 'ppr'],
    [enumCultureGlobal.pomme_terre]: ['pomme de terre', 'patate', 'potato', 'ptf']
};

/**
 * Dico avec clé provenant de l'enumerable de culture global
 */
export const CropNoSynonyms = {
    [enumCultureGlobal.colza]: [],
    [enumCultureGlobal.mais]: [],
    [enumCultureGlobal.ble]: ['bdh', 'dur', 'durum', 'duro'], 
    [enumCultureGlobal.ble_dur]: ['bth', 'tendre', 'soft', 'blando'],
    [enumCultureGlobal.orge]: [],
    [enumCultureGlobal.pois_printemps]: [],
    [enumCultureGlobal.pomme_terre]: []
}

export const CropHelper = {

    /**
     * Fonction permettant de verifier si le parcelCrop correspond avec les énumérés qu'on connait dans le dico
     * @param {Label} parcelCrop 
     * @param {enumCultureGlobal} cropEnum 
     * @param {boolean} isModelisation A utiliser dans le tableau de modelisation
     * @returns {boolean} true || false
     */
    checkCropByCropEnumAndParcelCrop(parcelCrop, cropEnum, isModelisation = false) { 
        if (!parcelCrop) return false;
        if (!cropEnum || cropEnum === enumCultureGlobal.unknown) return false;

        const cropLower = parcelCrop.toLowerCase(); //Permet de mettre la culture en texte minuscule

        if (isModelisation) {
            if (cropLower.includes("printemps") || cropLower.includes("primavera") || cropLower.includes("spring")) {
                return false;
            } 
        }

        let cropSynonyms = CropSynonyms[cropEnum];
        let cropNoSynonyms = CropNoSynonyms[cropEnum];

        // CropSynonyms si un synonyme et trouvé dans la culture de parcel 
        // et que si aucun non synonyme est inclue dans le culture de parcel 
        // alors on renvoi true sinon false
        if ((cropSynonyms.some(synonym => cropLower.includes(synonym))) && (cropNoSynonyms.every(notSynonym => !cropLower.includes(notSynonym)))) {
            return true;
        } else {
            return false;
        }
    },

    /**
     * Fonction permettant de réalisé un trie d'une liste de parcelle données en fonction de la culture
     * Fonction permettant de trié une liste de parcelle données en fonction de la culture
     * L'enum doit être global, c'est donc l'appellant qui ce charge de ça
     * @param {List} datas
     * @param {List} parcelIdFilteredList
     * @param {enumCultureGlobal} crop
     * @param {boolean} isModelisation A utiliser dans le tableau de modelisation
     */
    sortDataByCrop(datas, parcelIdFilteredList, crop, isModelisation = false) {
        if (parcelIdFilteredList !== undefined && parcelIdFilteredList !== null) {
            let parcelsList = [...datas];

            let parcelsListCultureFound = [];
            let parcelsListCultureNotFound = [];

            let parcelIdsSelected = [];
            let cultureIsSynonym = null;
            parcelsList.forEach(parcel => {
                if (parcel.culture !== null || parcel.culture !== undefined) {
                    cultureIsSynonym = this.checkCropByCropEnumAndParcelCrop(parcel.culture, crop, isModelisation);

                    if (cultureIsSynonym) {
                        parcelsListCultureFound.push(parcel);
                    }
                    else {
                        parcelsListCultureNotFound.push(parcel);
                    }
                }
                else {
                    parcelsListCultureNotFound.push(parcel);
                }
            });

            parcelsList = [...parcelsListCultureFound, ...parcelsListCultureNotFound];

            parcelsListCultureFound.forEach(parcel => {
                parcelIdsSelected.push(parcel.id);
            });

            return {
                parcelsList: parcelsList,
                parcelIdsSelected: parcelIdsSelected,
            };
        }
    },
}